import { Stack, Typography } from '@mui/material';
import { CustomCheckbox, FileUpload, RadioButtons } from 'Components';
import { yesNoOptions } from 'Constants';
import { Dictionary } from 'Dictionary';
import { DICTIONARY, FileCategories } from 'Enum';
import { useAppSelector, useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';
import { isFileExist } from 'Utils/isFileExist';

export const PoliceReport = () => {
  const { index, fieldId } = useContext(IndexContext);

  const filesList = useAppSelector(({ file: { files } }) => files);

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}.trafficAccidentSection`;

  const [isVehicleInsuranceExist, isPoliceReportFileClassified] = useWatch({
    name: [
      `${baseName}.isPoliceReportExist`,
      `${baseName}.isPoliceReportFileClassified`,
    ],
  });

  return (
    <>
      <RadioButtons
        id={dictionary.thirdSectionThirdFileUploadLabel}
        name={`${baseName}.isPoliceReportExist` as const}
        options={yesNoOptions}
        infoText={dictionary.thirdSectionThirdPoliceReportNote}
      />
      {isVehicleInsuranceExist && (
        <Stack gap='10px'>
          <Typography>{dictionary.thirdSectionThirdPoliceReportAdd}</Typography>
          <Stack>
            <FileUpload
              caseDetailsId={fieldId}
              fileLabel={dictionary.thirdSectionThirdFileUploadText}
              fileCategoryId={FileCategories.PoliceReport}
              ariaLabel={dictionary.thirdSectionThirdFileUploadLabel}
              disabled={isPoliceReportFileClassified}
            />
            {!isFileExist(filesList, FileCategories.PoliceReport) && (
              <CustomCheckbox
                name={`${baseName}.isPoliceReportFileClassified`}
                label={dictionary.classifiedInformationReportLater}
              />
            )}
          </Stack>
        </Stack>
      )}
    </>
  );
};
